enum StatusTransactionEnum {
  paided = 'P',
  waiting = 'W'
}

export default StatusTransactionEnum;
